import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {addSentryErrorLog} from '@npck/libs/commons';

import {AppModule} from './app/app.module';

const APP_INITIALIZED_ERROR_COUNT = 'app_initialized_error_count';
const preventAppInit = !!(window as any).PREVENT_APP_INIT;

if (!preventAppInit) {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .then(() => {
            addSentryErrorLog('App initialized successfully');
        })
        .catch(err => {
            const errorCount = Number(sessionStorage.getItem(APP_INITIALIZED_ERROR_COUNT)) || 0;
            sessionStorage.setItem(APP_INITIALIZED_ERROR_COUNT, String(errorCount + 1));
            if (errorCount <= 5) {
                addSentryErrorLog('App initialization failed, trying to reload the page. Step:' + errorCount);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
            console.error(err);
        });
}
